export default __webpack_public_path__ + "static/media/2-5.6875c237.png";